const isDebugEnabled = (): boolean => {
  if (typeof window === 'undefined') return false;

  if (!import.meta.env.DEV) return false;

  try {
    return (
      window.localStorage.getItem('debug_performans') === '1' ||
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    );
  } catch {
    return false;
  }
};

export const debugLog = (...args: unknown[]): void => {
  if (isDebugEnabled()) {
    console.log(...args);
  }
};
